import { FC } from 'react';

const BPSpinner: FC<{ width?: number }> = ({ width = 100 }) => (
  <svg
    width={width}
    height={width}
    className="animate-spin duration-[5000]"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMinYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.5}
      d="M100 50A50 50 0 1150 0v5.596A44.404 44.404 0 1094.404 50H100z"
      fill="url(#paint0_linear_117_43712)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_117_43712"
        x1={55.5556}
        y1={33.3333}
        x2={91.6667}
        y2={61.1111}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7652FF" />
        <stop offset={1} stopColor="#DED5FF" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);

export default BPSpinner;
